module.exports = require("jsonata");